import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-three-two',
  templateUrl: './c4-four-three-two.component.html',
  styleUrls: ['./c4-four-three-two.component.scss']
})
export class C4FourThreeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
